export default __webpack_public_path__ + "static/media/susie9.77c47499.jpg";